import { useI18N } from '../../../libraries/i18n/hook'
import Card from '../layout/Card'
import InfoText from '../layout/InfoText'

const AiDisclaimer = () => {
  const { t } = useI18N()
  return (
    <div className='w-full mx-auto mb-10 lg-mb-0'>
      <Card className='mt-6 border border-1 border-solid border-gray-200 text-gray'>
        <InfoText text={t('ai.disclaimer')} iconColor='gray'/>
      </Card>
    </div>
  )
}

export default AiDisclaimer
